import modular from 'modujs';
import * as modules from './modules';
import globals from './globals';
import shared from './shared';
import { $html, $body } from './utils/dom';
import { ENV, CSS_CLASS, CUSTOM_EVENT } from './config'
import gsap from "gsap";

const app = new modular({
    modules,
});

function init() {
    globals();
    shared();

    app.init(app);

    $html.classList.add(CSS_CLASS.LOADED, CSS_CLASS.READY);
    $html.classList.remove(CSS_CLASS.LOADING);

    /**
     * Debug focus
     */
    // document.addEventListener(
    //     "focusin",
    //     function () {
    //         console.log('focused: ', document.activeElement)
    //     }, true
    // );
}

////////////////
// Execute
////////////////
window.addEventListener('load', () => {
    init();

    if ($body.classList.contains('error404')) {
        window.dispatchEvent(new Event("loading-hide"));
    } else {
        window.dispatchEvent(new Event("loading-pct"));
    }
});
